import React from "react"
import styled from "styled-components"
import ChangePasswordButton from "./ChangePasswordButton"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px;
  border: ${({theme}) => theme.borders.main};
  border-radius: ${({theme}) => theme.borderRadius.main};
`

const ColumnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const RowGroup = styled.div`
  display: flex;
  gap: 10px;
`

export default ({
  userAccount
}) => {
  const { email = '' } = userAccount || {}

  return (
    <Container>
      <ColumnGroup>
        <div>Account Email</div>
        <div>Your login email address is <strong>{email}</strong></div>
      </ColumnGroup>
      <RowGroup>
        <ColumnGroup>
          <div>Change Password</div>
          <div>Click 'Change' to update your password</div>
        </ColumnGroup>
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <ChangePasswordButton userAccount={userAccount} />
        </div>
      </RowGroup>
    </Container>
  )
}
